import React, { useMemo, useState } from 'react';
import useWatchError from '../../../../shared/hooks/useWatchError';
import useMyWorkspacesChildren from '../../../../redux/workspace/hooks/useMyWorkspacesChildren';
import { Stack } from '@mui/material';
import WorkspaceItem, { WorkspaceItemSkeleton } from './WorkspaceItem';
import WorkspaceListLayout from './WorkspaceListLayout';
import WorkspaceDashboard from './WorkspaceDashboard';

function WorkspaceSkeletons() {
  return (
    <Stack spacing={1}>
      {[...Array(3)].map((_, index) => (
        <WorkspaceItemSkeleton key={index} />
      ))}
    </Stack>
  );
}

function WorkspaceAdminList() {
  const {
    data: workspacesChildren,
    error: workspacesChildrenError,
    isLoading: workspacesChildrenLoading,
  } = useMyWorkspacesChildren();

  const error = workspacesChildrenError;
  useWatchError(error);
  const listWorkspace = useMemo(
    () => Object.values(workspacesChildren || {}),
    [workspacesChildren]
  );
  const [workspaceIdSelected, setWorkspaceIdSelected] = useState<string | null>(
    null
  );
  const onClickWorkspace = (workspaceId: string) => () => {
    if (workspaceId === workspaceIdSelected) {
      setWorkspaceIdSelected(null);
      return;
    }
    setWorkspaceIdSelected(workspaceId);
  };

  const onSearch = (item: any) => {
    setWorkspaceIdSelected(item.id);
  };
  const showRightPanel = Boolean(workspaceIdSelected);

  const content = workspacesChildrenLoading ? (
    <WorkspaceSkeletons />
  ) : (
    <Stack spacing={1}>
      {listWorkspace?.map((workspace) => (
        <WorkspaceItem
          workspaceId={workspace.childId}
          workspaceIdSelected={workspaceIdSelected}
          key={workspace.childId}
          onClick={onClickWorkspace(workspace.childId)}
        />
      ))}
    </Stack>
  );

  return (
    <WorkspaceListLayout
      innerContainerMaxWidth={'lg'}
      role="markets"
      onSearch={onSearch}
      showRightPanel={showRightPanel}
      rightPanel={<WorkspaceDashboard workspaceId={workspaceIdSelected} />}
    >
      {content}
    </WorkspaceListLayout>
  );
}

export default WorkspaceAdminList;
